import { SideNavBar } from './Util';
import '../styles/Portfolio.css';
export function Portfolio() {

    // const resumeDownload = () => {
    //     //update pdf path 
    //     const pdfUrl = 'https://github.com/theDorime/cindyc/raw/gallery-database/src/assets/Resume.pdf';

    //     const link = document.createElement('a');
    //     link.href = pdfUrl;
    //     link.style.display = 'none';
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);

    //   };

   return <div>
        {SideNavBar('Portfolio', '')}

        <h3 className='portAlign'> For my resume and stuff <br/><br/>

        <a href="https://github.com/theDorime/cindyc">
            <button type="button" class="btn btn-dark">Site's Github Repo</button>
        </a>
        
        <br/><br/>
        
        </h3>
    </div>
};